module.exports = "/_next/static/images/main-visual-idea@2x-30c0e5046431a814ea0907804b6cef9a.jpg";